export default class {
  constructor(IntegrationService, PersonaCollection, Utils, $uibModalInstance, integration) {
    'ngInject';

    Object.assign(this, {
      IntegrationService,
      PersonaCollection,
      Utils,
      $uibModalInstance,
      integration,
    });

    this.init();
  }

  async init() {
    this.locationOptions = [
      {
        label: "It's a new location",
        value: null,
        separatorAfter: true,
      },
      ...this.PersonaCollection.locations.map((loc) => ({
        label: loc.name,
        value: loc.id,
      })),
    ];

    this.loading = true;
    try {
      const locationsToMap = await this.IntegrationService.getLocationsToMap(this.integration);
      this.locationsToMap = locationsToMap.filter((item) => !item.coreId);

      if (!this.locationsToMap.length) {
        this.$uibModalInstance.close();
        return;
      }

      this.locationsToMap.forEach((locationToMap) => {
        const coreLocationMatch = this.PersonaCollection.locations.find(
          (loc) => loc.name.toLowerCase() === locationToMap.name.toLowerCase()
        );
        if (coreLocationMatch) {
          locationToMap.coreId = coreLocationMatch.id;
        } else {
          locationToMap.coreId = null;
        }
      });
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    this.error = null;
    this.form.$setSubmitted();

    if (!this.form.$valid) {
      throw 'invalid form';
    }

    const payload = this.locationsToMap
      .filter((item) => item.coreId !== undefined)
      .reduce((agg, item) => ((agg[item.id] = item.coreId), agg), {});

    await this.IntegrationService.sync(this.integration, {
      location_mapping: payload,
    });

    this.$uibModalInstance.close();
  }

  coreIdsCollideWith(locationToMap) {
    return this.locationsToMap.some(
      (item) => item !== locationToMap && item.coreId === locationToMap.coreId
    );
  }

  isFormValid() {
    const mapping = this.locationsToMap
      .filter((item) => item.coreId !== undefined)
      .map((item) => item.coreId);
    return mapping.length === this.Utils.uniq(mapping);
  }
}
